<div class="inset-spacer"></div>
<!-- 데스크탑용 헤더 -->
<div class="header desktop">
  <div class="bar-left">
    <!-- 책판 -->
    <div class="bar-item icon">
      <button
        *ngIf="!_isApp"
        class="icon-text-button"
        (click)="_onMenuItemClick(MenuItem.BookHome)"
      >
        <div class="icon">
          <sui-icon name="책 정보" type="solid"></sui-icon>
        </div>
        책판
      </button>
      <button
        *ngIf="_isApp"
        class="button left"
        sui-icon-button
        (click)="_onMenuItemClick(MenuItem.Back)"
      >
        <sui-icon name="원형 이동_왼쪽"></sui-icon>
      </button>
    </div>

    <!-- 목차 -->
    <div class="bar-item icon">
      <button class="icon-text-button" (click)="_onMenuItemClick(MenuItem.TOC)">
        <div class="icon">
          <sui-icon name="앱_도서 리스트" type="solid"></sui-icon>
        </div>
        목차
      </button>
    </div>

    <!-- 페이지 목록 -->
    <div class="bar-item icon" *ngIf="_isPDFMode">
      <button
        class="icon-text-button"
        (click)="_onMenuItemClick(MenuItem.Thumbnail)"
      >
        <div class="icon">
          <sui-icon name="페이지 모아보기"></sui-icon>
        </div>
        페이지 목록
      </button>
    </div>

    <!-- 뷰어 설정 -->
    <div class="bar-item icon">
      <button
        class="icon-text-button"
        (click)="_onMenuItemClick(MenuItem.Settings)"
      >
        <div class="icon">
          <sui-icon name="환경설정"></sui-icon>
        </div>
        뷰어 설정
      </button>
    </div>

    <!-- 도움말 -->
    <div class="bar-item icon">
      <button
        class="icon-text-button"
        (click)="_onMenuItemClick(MenuItem.Help)"
      >
        <div class="icon">
          <sui-icon name="도움말" type="solid"></sui-icon>
        </div>
        도움말
      </button>
    </div>

    <!-- 책판 제목, 그룹책 종류, 그룹원 수 -->
    <div class="bar-item main">
      <div class="title">{{ _book?.meta?.title }}</div>
      <ng-container *ngIf="!_isCommentaryEditorMode">
        <span class="my-book-label" *ngIf="_groupMemberCount === 0"
          >혼자 읽기 중</span
        >
        <ng-container *ngIf="_groupMemberCount > 0">
          <button
            class="member-count-button"
            [class.disabled]="!_isOwnedByUser"
            (click)="_onMenuItemClick(MenuItem.GroupMembers)"
          >
            {{ _groupMemberCount }}
          </button>
          <span class="member-count-label">
            명이 '{{ _currentGroupName }}' 그룹책 함께읽는 중
          </span>
        </ng-container>
        <button
          class="round-button mode-button"
          *ngIf="!_isSupplementViewer && _isOwnedByUser && !isGroupReading"
          [cdkMenuTriggerFor]="readingModeMenu"
        >
          <sui-icon name="뷰어 그룹 변경"></sui-icon>그룹책 보기
        </button>
        <button
          class="round-button mode-button"
          *ngIf="!_isSupplementViewer && _isOwnedByUser && isGroupReading"
          (click)="_changeToMyBookViewer()"
        >
          <sui-icon name="뷰어 그룹 변경"></sui-icon>나의책 보기
        </button>
      </ng-container>
      <!-- <div
        class="inbox-button"
        [class.is-active]="_hasNewNote"
        *ngIf="_groupMemberCount > 0"
      >
        <button sui-icon-button (click)="_onMenuItemClick(MenuItem.Inbox)">
          <sui-icon name="메세지" type="solid"></sui-icon>
        </button>
      </div> -->
    </div>

    <!-- 필기 모드, 북마크, 검색 -->
    <div class="bar-item-right">
      <!-- 필기 모드 (PDF 뷰어에서만 노출) -->
      <button
        *ngIf="_isPDFMode"
        class="button"
        [class.disabled]="!_isOwnedByUser"
        sui-icon-button
        (click)="_onMenuItemClick(MenuItem.DrawingMode)"
      >
        <sui-icon
          name="펜"
          [type]="_isDrawingMode ? 'solid' : 'outline'"
        ></sui-icon>
      </button>

      <!-- 북마크 (나의책 보기와 코멘터리에디터 모드가 아닐때 노출) -->
      <button
        *ngIf="!_isCommentaryEditorMode && !isGroupReading"
        class="button"
        [class.disabled]="!_isOwnedByUser"
        sui-icon-button
        (click)="_onMenuItemClick(MenuItem.Bookmark)"
      >
        <sui-icon
          name="북마크"
          [type]="_bookmarked ? 'solid' : 'outline'"
        ></sui-icon>
      </button>

      <!-- 검색 (검색이 가능한 뷰어에서만 노출) -->
      <button
        *ngIf="_canSearchText"
        class="button"
        [class.disabled]="!_isOwnedByUser"
        sui-icon-button
        (click)="_onMenuItemClick(MenuItem.Search)"
      >
        <sui-icon name="검색"></sui-icon>
      </button>
    </div>
  </div>

  <!-- 알림, 메세지, 내 기록, 전체 댓글 -->
  <div class="bar-right">
    <!-- 알림 -->
    <button
      class="button"
      [class.disabled]="!_isOwnedByUser"
      sui-icon-button
      (click)="_onMenuItemClick(MenuItem.Notification)"
    >
      <sui-icon
        [class.is-active]="_hasNewNotification"
        name="알림"
        type="solid"
      ></sui-icon>
    </button>

    <!-- 메세지 -->
    <button
      class="button"
      [class.disabled]="!_isOwnedByUser"
      sui-icon-button
      (click)="_onMenuItemClick(MenuItem.Inbox)"
    >
      <sui-icon
        [class.is-active]="_hasNewNote"
        name="메세지"
        type="solid"
      ></sui-icon>
    </button>

    <!-- 내 기록, 전체 댓글 -->
    <div class="my-record-wrapper">
      <!-- 내 기록 (나의책 보기와 댓글창 패널이 열려있지 않을때 노출) -->
      <button
        class="my-record-button"
        *ngIf="!isGroupReading && !_isRightPanelOpened"
        (click)="_onMenuItemClick(MenuItem.MyRecord)"
      >
        내 기록
      </button>

      <!-- 전체 댓글 (그룹책 보기와 댓글창 패널이 열려있지 않을때 노출) -->
      <div
        class="group-memo-button"
        *ngIf="isGroupReading && !_isRightPanelOpened"
      >
        <button
          class="round-button"
          (click)="_onMenuItemClick(MenuItem.GroupMemos)"
          *ngIf="!_isUnderline"
        >
          전체 댓글
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 모바일용 헤더 -->
<div class="header mobile">
  <button
    class="button left"
    sui-icon-button
    (click)="_onMenuItemClick(MenuItem.Back)"
  >
    <sui-icon name="원형 이동_왼쪽"></sui-icon>
  </button>
  <div class="expand"></div>

  <!-- 필기 모드 (PDF 뷰어에서만 노출) -->
  <button
    *ngIf="_isPDFMode"
    class="button right"
    [class.disabled]="!_isOwnedByUser"
    sui-icon-button
    (click)="_onMenuItemClick(MenuItem.DrawingMode)"
  >
    <sui-icon
      name="펜"
      [type]="_isDrawingMode ? 'solid' : 'outline'"
    ></sui-icon>
  </button>

  <!-- 북마크 (나의책 보기와 코멘터리에디터 모드가 아닐때 노출) -->
  <button
    *ngIf="!_isCommentaryEditorMode && !isGroupReading"
    class="button right"
    [class.disabled]="!_isOwnedByUser"
    sui-icon-button
    (click)="_onMenuItemClick(MenuItem.Bookmark)"
  >
    <sui-icon
      name="북마크"
      [type]="_bookmarked ? 'solid' : 'outline'"
    ></sui-icon>
  </button>

  <!-- 검색 (검색이 가능한 뷰어에서만 노출) -->
  <button
    class="button right"
    [class.disabled]="!_isOwnedByUser"
    sui-icon-button
    *ngIf="_canSearchText"
    (click)="_onMenuItemClick(MenuItem.Search)"
  >
    <sui-icon name="검색"></sui-icon>
  </button>

  <!-- 알림 -->
  <div
    class="button right inbox-button-mobile"
    [class.is-active]="_hasNewNotification"
  >
    <button
      class="button right"
      [class.is-active]="_hasNewNotification"
      [class.disabled]="!_isOwnedByUser"
      sui-icon-button
      (click)="_onMenuItemClick(MenuItem.Notification)"
    >
      <sui-icon name="알림" type="solid"></sui-icon>
    </button>
  </div>

  <!-- 메세지 -->
  <div class="button right inbox-button-mobile" [class.is-active]="_hasNewNote">
    <button
      class="button right"
      [class.disabled]="!_isOwnedByUser"
      [class.is-active]="_hasNewNote"
      sui-icon-button
      (click)="_onMenuItemClick(MenuItem.Inbox)"
    >
      <sui-icon name="메세지" type="solid"></sui-icon>
    </button>
  </div>
</div>

<ng-template #readingModeMenu>
  <ng-container *ngIf="_groups.length > 0">
    <sui-menu cdkMenu>
      <button
        sui-menu-item
        cdkMenuItem
        *ngFor="let group of _groups"
        class="group-item"
        (click)="_onClickReadingGroup(group)"
      >
        <span>{{ group.name }}</span>
        <sui-icon
          *ngIf="group.is_liked"
          name="즐겨찾기"
          type="solid"
        ></sui-icon>
      </button>
    </sui-menu>
  </ng-container>

  <div class="no-group-message" *ngIf="_groups.length === 0">
    <p>현재 읽고 있는 그룹책이 없습니다</p>
    <span class="link" (click)="_onMenuItemClick(MenuItem.ReadingMode)"
      >그룹책 둘러보기</span
    >
  </div>
</ng-template>
